import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const MileageForCanters = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [date, setDate] = useState(new Date().toISOString());
  const [showRequest, setShowRequest] = useState(false);
  const [searchRequest, setSearchRequest] = useState("");
  const [showContract, setShowContract] = useState(false);
  const [searchContract, setSearchContract] = useState("");
  const [showRoute, setShowRoute] = useState(false);
  const [searchRoute, setSearchRoute] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [requestNo, setRequestNo] = useState("");
  const [firstRequestNo, setFirstRequestNo] = useState("");
  const [latestRequestNo, setLatestRequestNo] = useState("");
  const [newRequestNo, setNewRequestNo] = useState("");
  const [contractsList, setContractsList] = useState([]);
  const [contractNo, setContractNo] = useState("");
  const [routesList, setRoutesList] = useState([]);
  const [routeNo, setRouteNo] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [selDriverName, setSelDriverName] = useState("");
  const [selDriverCode, setSelDriverCode] = useState("");
  const [driverList, setDriverList] = useState([]);
  const [selMileageType, setSelMileageType] = useState("");
  const [mileageTypeList, setMileageTypeList] = useState([]);
  const [currency, setCurrency] = useState("");
  const [exchRate, setExchRate] = useState("");
  const [selPaymentMode, setSelPaymentMode] = useState("");
  const [mileageAmountReq, setMileageAmountReq] = useState("");
  const [reqAmount, setReqAmount] = useState("");
  const [headerData, setHeaderData] = useState([]);
  const [dataOfMileageIssue, setDataOfMileageIssue] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [truckNo, setTruckNo] = useState("");
  const [make, setMake] = useState("");
  const [trucksList, setTrucksList] = useState([]);
  const [narration, setNarration] = useState("");
  const [selectedDataForApproval, setSelectedDataForApproval] = useState([]);
  const [hist, setHist] = useState(false);
  const [duplicate, setDuplicate] = useState(false);
  const [routeDistance, setRouteDistance] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [refNo, setRefNo] = useState("");
  const [standardOrVariable, setStandardOrVariable] = useState("");
  const [company, setCompany] = useState({});
  const [isDocPrinted, setIsDocPrinted] = useState(false);
  const [PopUpReport, setPopUpReport] = useState(false);
  const [LoadingScreenBlock, setLoadingScreenBlock] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [isApproved, setIsApproved] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [reasonToCancel, setReasonToCancel] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [startDate, setStartDate] = useState(new Date().toISOString());
  const [endDate, setEndDate] = useState(new Date().toISOString());
  const [openingKm, setOpeningKm] = useState("");
  const [closingKm, setClosingKm] = useState("");
  const [shsPerKm, setShsPerKm] = useState("");
  const [mileageVoucherNo, setMileageVoucherNo] = useState("");

  const getWeekRange = () => {
    const today = new Date();

    const day = today.getDay(); // 0 (Sun) - 6 (Sat)

    // Make Monday as start of week
    const diffToMonday = day === 0 ? -6 : 1 - day;

    const start = new Date(today);
    start.setDate(today.getDate() + diffToMonday);
    start.setHours(0, 0, 0, 0);

    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);

    return {
      startDates: start.toISOString(),
      endDates: end.toISOString(),
    };
  };

  const { startDates, endDates } = getWeekRange();

  const [headerStartDate, setHeaderStartDate] = useState(startDates);
  const [headerEndDate, setHeaderEndDate] = useState(endDates);

  const [PopUpReportMM, setPopUpReportMM] = useState(false);
  const [LoadingScreenBlockMM, setLoadingScreenBlockMM] = useState(false);
  const [pdfDataMM, setPdfDataMM] = useState(null);

  // Filter Contracts
  const filteredContracts = contractsList.filter((item) => {
    const searchData = searchContract.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["CLIENTMAME", "CONTRACTNO", "CARGO"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  // Filter Routes
  const filteredRoutes = routesList.filter((item) => {
    const searchData = searchRoute.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["ENDLOC", "STARTLOC", "ROUTEID", "DISTANCE"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  // Filter Request
  const filteredRequest = headerData.filter((item) => {
    const searchData = searchRequest.toLowerCase().split(" ").filter(Boolean);
    const sDate = new Date(item.OT_REQUEST_DATE);
    const eDate = new Date(item.OT_REQUEST_DATE);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    if (searchData.length === 0 && !startDate && !endDate) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "OT_REQUEST_NO",
        "OT_REQUEST_MILEAGE_TYPE",
        "OT_REQUEST_INVOICE_NUMBER",
        "OT_REQUEST_VEHICLE",
        "DRIVERNAME",
        "OT_REQUEST_NARRATION",
        "OT_REQUEST_OPENING_KM",
        "OT_REQUEST_CLOSING_KM",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const dateMatch = (!start || sDate >= start) && (!end || eDate <= end);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((res) => {
        setCompany(res?.data[0]);
      })
      .catch((err) => {
        console.log("Error While fetching Company Details", err);
      });

    // New Request Id
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1117`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setRequestNo(response?.data[0]?.NEWID);
        setLatestRequestNo(response?.data[0]?.NEWID);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching New Request No:", error);
      });

    // New Mileage Voucher
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=400`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setMileageVoucherNo(response?.data[0]?.MILEAGEVOUCHERNO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching New Request No:", error);
      });

    // ROUTES LIST
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=524`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setRoutesList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Route Details:", error);
      });

    // Drivers List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriverList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver Details:", error);
      });

    // Vehicles List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setTrucksList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicles Details:", error);
      });

    // View Expense
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1119`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setMileageTypeList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Mileage Type Details:", error);
      });

    // 1116
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1116`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const sortedData = [...(response?.data || [])].sort(
          (a, b) => Number(b.OT_REQUEST_NO) - Number(a.OT_REQUEST_NO),
        );
        setDataOfMileageIssue(sortedData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Header Details:", error);
      });

    // 1414
    //  Header Data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1414`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const sortedData = [...(response?.data || [])].sort(
          (a, b) => Number(b.OT_REQUEST_NO) - Number(a.OT_REQUEST_NO),
        );
        setHeaderData(sortedData);
        setFirstRequestNo(response?.data[0]?.OT_REQUEST_NO);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Header Details:", error);
      });
  };

  function getChildData(vehicle) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1095&OT_LOADING_ADVISE_VEHICLE_NO=${vehicle}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      )
      .then((response) => {
        const updatedData = response.data.map((item) => {
          const match = dataOfMileageIssue.find(
            (h) =>
              h.OT_REQUEST_MILEAGE_TRUCK_NO ===
              item.OT_LOADING_ADVISE_VEHICLE_NO,
          );

          return {
            OT_LOADING_ORDER_NO: item?.OT_LOADING_ADVISE_NO || null,
            OT_LOADING_DATE: item?.OT_LOADING_ADVISE_DATE || null,
            OT_CLIENT_INVOICE_NO: match?.SALESINVOICENO || null,
          };
        });
        setTableData(updatedData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Mileage Type Details:", error);
      });
  }

  async function getNewRequestNo() {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1117`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setRequestNo(response?.data[0]?.NEWID);
        setLatestRequestNo(response?.data[0]?.NEWID);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching New Request No:", error);
      });
  }

  // Saving
  async function Save() {
    // if (duplicate === true) {
    //   for (let index = 0; index < tableData.length; index++) {
    //     const value = tableData[index];
    //     const isInvoiceExisting = headerData?.find(
    //       (item) =>
    //         item?.OT_REQUEST_MILEAGE_TYPE === value?.OT_REQUEST_MILEAGE_TYPE &&
    //         item?.OT_REQUEST_DRIVER_CODE === value?.OT_REQUEST_DRIVER_CODE &&
    //         item?.OT_REQUEST_MILEAGE_TRUCK_NO ===
    //           value?.OT_REQUEST_MILEAGE_TRUCK_NO &&
    //         item?.SALESINVOICENO === value?.SALESINVOICENO,
    //     );
    //     if (isInvoiceExisting) {
    //       alert(
    //         `This Invoice No: ${value?.SALESINVOICENO} is already attached with the Mileage Type: ${value?.OT_REQUEST_MILEAGE_TYPE} and Vehicle: ${value?.OT_REQUEST_MILEAGE_TRUCK_NO}`,
    //       );
    //       return;
    //     }
    //   }
    // }

    if (Number(openingKm) > Number(closingKm)) {
      alert("OPENING KM can not be greater than CLOSING KM");
      return;
    }

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1412`,
        {
          OT_REQUEST_NO: Number(requestNo),
          OT_REQUEST_DATE: moment(date).format("YYYY/MM/DD"),
          OT_REQUEST_PROCESSED_BY: user ? user : "",
          OT_REQUEST_PROCESSED_DATE: moment(date).format("YYYY/MM/DD")
            ? moment(date).format("YYYY/MM/DD")
            : "",
          OT_REQUEST_NARRATION: narration ? narration : "",
          OT_REQUEST_INVOICE_NUMBER: refNo ? refNo : 0,

          OT_REQUEST_VEHICLE: truckNo ? truckNo : "",
          OT_REQUEST_VEHICLE_MAKE: make ? make : "",
          OT_REQUEST_DRIVER_CODE: selDriverCode ? selDriverCode : "",
          OT_REQUEST_OPENING_KM: openingKm ? openingKm : 0,
          OT_REQUEST_CLOSING_KM: closingKm ? closingKm : 0,
          OT_REQUEST_MILEAGE_TYPE: selMileageType ? selMileageType : "",
          OT_REQUEST_START_DATE: startDate
            ? moment(startDate).format("YYYY/MM/DD")
            : "",
          OT_REQUEST_END_DATE: endDate
            ? moment(endDate).format("YYYY/MM/DD")
            : "",
          OT_REQUEST_NEW_EXISTING: hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        console.log(response);
        console.log(`Request Header Saved successfully`);
        await SaveDetails(response?.data?.message);
      } else {
        alert(`Error while saving Request Header`);
        setisloading(false);
        console.error(`Error while saving Request Header`);
      }
    } catch (error) {
      alert(`Error while saving Request Header`, error);
      setisloading(false);
      console.error(`Error while saving Request Header`, error);
    }
  }

  async function SaveDetails(docNo) {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let index = 0; index < selectedDataForApproval.length; index++) {
      const value = selectedDataForApproval[index];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1413`,
          {
            OT_REQUEST_NO: docNo ? Number(docNo) : Number(requestNo),
            OT_LOADING_ORDER_NO: value?.OT_LOADING_ORDER_NO
              ? Number(value?.OT_LOADING_ORDER_NO)
              : 0,
            OT_LOADING_DATE: value?.OT_LOADING_DATE
              ? moment(value?.OT_LOADING_DATE).format("YYYY/MM/DD")
              : "",
            OT_CLIENT_INVOICE_NO: value?.OT_CLIENT_INVOICE_NO
              ? value?.OT_CLIENT_INVOICE_NO
              : "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while Saving Details`, error);
        alert(error.response.data.message);
      }
    }
    setisloading(false);
    if (successCount == selectedDataForApproval.length && successMessage) {
      //   alert(successMessage);
      alert(`Request for Canters Saved successfully`);
      // const toPrint = window.confirm("Do you want to print?");
      // if (toPrint) {
      //   setPopUpReport(true);
      //   generateReport(requestNo);
      // } else {
      window.location.reload();
      // }
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  async function getMileageVoucherNo() {
    try {
      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=400`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );
      if (response.status === 201) {
        return response?.data[0]?.MILEAGEVOUCHERNO;
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error(`Error while generating Mileage Voucher Number`, error);
      alert("Failed to generate Mileage Voucher Number");
    }
  }

  const handleCheckboxChange = (row) => {
    setSelectedDataForApproval((prevSelected) => {
      const exists = prevSelected.some(
        (selectedRow) =>
          selectedRow.OT_LOADING_ORDER_NO === row.OT_LOADING_ORDER_NO,
      );
      if (exists) {
        // remove if already selected
        return prevSelected.filter(
          (selectedRow) =>
            !(selectedRow.OT_LOADING_ORDER_NO === row.OT_LOADING_ORDER_NO),
        );
      } else {
        // add new row
        return [...prevSelected, row];
      }
    });
  };

  const isRowChecked = (row) => {
    if (row?.MILEAGEAPPROVED === true) return true;
    if (!row || !row?.OT_LOADING_ORDER_NO) return false;
    return selectedDataForApproval.some(
      (r) => r?.OT_LOADING_ORDER_NO === row?.OT_LOADING_ORDER_NO,
    );
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      // Select all rows currently visible in filterData
      setSelectedDataForApproval(tableData);
    } else {
      // Unselect all
      setSelectedDataForApproval([]);
    }
  };

  // PRINT BIT FLAG
  async function PrintUpdate() {
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1404`,
        {
          DOCNO: Number(requestNo),
          PROCESSEDBY: user ? user : "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Request Header Saved successfully`);
      } else {
        alert(`Error while Logging Print`);
        console.error(`Error while Logging Print`);
      }
    } catch (error) {
      alert(`Error while saving Logging Print`, error);
      console.error(`Error while Logging Print`, error);
    }
  }

  function generateReport(DNOTEno) {
    setPdfData(null);

    setLoadingScreenBlock(true);

    axios
      .post(
        `${BASEURL}/generateReports`,
        {
          REPORTNAME: "CrMileageRequest.rpt",
          DOCNO: DNOTEno,
          // REPORTPATH: `C:\\AUTOEMAILS\\SGC`.replace(/\\\\/g, "\\"), // Converts \\ to \ for the request
          REPORTPATH: company?.REPORTPATH,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
          responseType: "blob",
        },
      )
      .then(async (res) => {
        console.log(res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfData(fileURL);
        setLoadingScreenBlock(false);
        await PrintUpdate();
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlock(false);
      });
  }

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = pdfData;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // Generate Report Date
  function generateReportMM() {
    setPdfDataMM(null);
    const endDataFormat =
      endDate.slice(8, 10) +
      "/" +
      endDate.slice(5, 7) +
      "/" +
      endDate.slice(0, 4);
    const startDataFormat =
      startDate.slice(8, 10) +
      "/" +
      startDate.slice(5, 7) +
      "/" +
      startDate.slice(0, 4);
    console.log(endDataFormat);
    setLoadingScreenBlockMM(true);

    axios
      .post(
        `${BASEURL}/generatereport`,
        {
          REPORTNAME: "CrMonthtoDateMileageDetailedReport.rpt",
          STARTDATE: startDataFormat,
          ENDDATE: endDataFormat,
          DIVISIONBASED: "NO",
          DIVISIONNAME: "",
          SINGLEMULTIDATE: "Date Range",
          REPORTPATH: company?.REPORTPATH,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
          responseType: "blob", // Important for handling binary data
          timeout: 60000, // Set timeout to 60 seconds (60000 milliseconds)
        },
      )
      .then((res) => {
        console.log(res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfDataMM(fileURL);
        setLoadingScreenBlockMM(false);
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlockMM(false);
      });
  }

  const handleDownloadMM = () => {
    const a = document.createElement("a");
    a.href = pdfDataMM;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleButtonClick = (action) => {
    let requestNoToPass;
    switch (action) {
      case "first":
        requestNoToPass = Number(firstRequestNo);
        break;
      case "decrement":
        requestNoToPass = Number(requestNo) - 1;
        if (requestNoToPass < Number(firstRequestNo)) {
          alert("Cannot decrement further");
          return;
        }
        break;

      case "increment":
        requestNoToPass = Number(requestNo) + 1;
        if (requestNoToPass >= Number(latestRequestNo)) {
          alert("No Further PO number");
          return;
        }
        break;

      case "latest":
        requestNoToPass = Number(latestRequestNo) - 1;
        break;
      default:
        break;
    }

    getNavData(requestNoToPass);
  };

  async function getNavData(request) {
    const item = headerData?.find((value) => value?.OT_REQUEST_NO === request);

    if (item) {
      setRequestNo(item?.OT_REQUEST_NO);
      setDate(item?.OT_REQUEST_DATE);
      setNarration(item?.OT_REQUEST_NARRATION);
      setRefNo(item?.OT_REQUEST_INVOICE_NUMBER);
      setIsDocPrinted(item?.OT_REQUEST_PRINTED == true ? true : false);
      setCreatedBy(item?.OT_REQUEST_PROCESSED_BY);
      setCreatedDate(item?.OT_REQUEST_PROCESSED_DATE);
      setShowRequest(false);
      setTruckNo(item?.OT_REQUEST_VEHICLE);
      setMake(item?.OT_REQUEST_VEHICLE_MAKE);
      setSelDriverCode(item?.OT_REQUEST_DRIVER_CODE);
      setSelDriverName(item?.DRIVERNAME);
      setOpeningKm(item?.OT_REQUEST_OPENING_KM);
      setClosingKm(item?.OT_REQUEST_CLOSING_KM);
      setSelMileageType(item?.OT_REQUEST_MILEAGE_TYPE);
      setStartDate(item?.OT_REQUEST_START_DATE);
      setEndDate(item?.OT_REQUEST_END_DATE);
      setIsCancelled(item?.OT_REQUEST_CANCELLED);
      setIsApproved(item?.OT_REQUEST_APPROVED);
      const filtered = headerData?.filter(
        (items) => items.OT_REQUEST_NO === item?.OT_REQUEST_NO,
      );

      setTableData(filtered);
      setHist(true);
      setShowTable(true);
    } else {
      // Auto-decrement if record not found
      const allVouchers = [...(headerData || [])]
        .map((item) => Number(item?.OT_REQUEST_NO))
        .sort((a, b) => a - b);

      const currentDispatch = Number(request);

      // Determine whether this was likely an increment or decrement action
      const lastDispatchNo = Number(requestNo);

      const isIncrement = currentDispatch > lastDispatchNo;

      if (isIncrement) {
        // Find next existing record greater than the current one
        const nextExisting = allVouchers.find((num) => num > currentDispatch);
        if (nextExisting !== undefined) {
          console.warn(
            `request No ${request} not found, trying ${nextExisting}`,
          );
          await getNavData(nextExisting);
          return;
        } else {
          alert(`No further request No found after ${request}`);
        }
      } else {
        const previousExisting = [...allVouchers]
          .reverse()
          .find((num) => num < Number(request));

        if (previousExisting !== undefined) {
          console.warn(
            `request No ${request} not found, trying ${previousExisting}`,
          );
          await getNavData(previousExisting);
          return;
        } else {
          alert(`No existing request No found before ${request}`);
        }
      }
    }
  }

  // ********** EXPORT TO PDF AND EXCEL **************

  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Batch Mileage Issue Request");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [15, 15, 15, 15, 25, 25, 25, 25, 25, 15, 15, 15, 35];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "REQUEST NO",
      "REQUEST DATE",
      "REF NO",
      "ROUTE ID",
      "FROM",
      "TO",
      "VEHICLE",
      "DRIVER",
      "MILEAGE TYPE",
      "AMOUNT",
      "CANCELLED",
      "INVOICE NO",
      "NARRATION",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Batch_Mileage_Issue_Request.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("Batch Mileage Issue Request - Report", 10, 10);

    const columns = [
      "REQUEST NO",
      "REQUEST DATE",
      "REF NO",
      "ROUTE ID",
      "FROM",
      "TO",
      "VEHICLE",
      "DRIVER",
      "MILEAGE TYPE",
      "AMOUNT",
      "CANCELLED",
      "INVOICE NO",
      "NARRATION",
    ];

    const data = filteredRequest.map((stock) => {
      const route = routesList?.find(
        (item) => item.ROUTEID == stock.OT_REQUEST_ROUTE_NO,
      );
      return [
        stock.OT_REQUEST_NO,
        stock.OT_REQUEST_DATE
          ? moment(stock.OT_REQUEST_DATE).format("DD/MM/YYYY")
          : "",
        stock.OT_REQUEST_INVOICE_NUMBER,
        stock.OT_REQUEST_ROUTE_NO,
        route?.STARTLOC,
        route?.ENDLOC,
        stock.OT_REQUEST_MILEAGE_TRUCK_NO,
        stock.DRIVERNAME,
        stock.OT_REQUEST_MILEAGE_TYPE,
        stock.OT_REQUEST_MILEAGE_AMOUNT,
        stock.MILEAGECANCELLED === true ? "YES" : "NO",
        stock.SALESINVOICENO,
        stock.OT_REQUEST_NARRATION,
      ];
    });

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Batch_Mileage_Issue_Request.pdf");
  };

  async function Approve() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1443`,
        {
          MILEAGEVOUCHERNO: Number(mileageVoucherNo),
          DOCNO: requestNo ? Number(requestNo) : 0,
          MILEAGETYPE: selMileageType ? selMileageType : "",
          DRIVERCODE: selDriverCode ? selDriverCode : "",
          APPROVEDBY: user ? user : "",
          CONTRACTNO: 0,
          ISSUEDATE: date ? moment(date).format("YYYY/MM/DD") : "",
          DRIVERNAME: selDriverName ? selDriverName : "",
          MILEAGEAMOUNT: 0,
          NARRATION: narration ? narration : "",
          CURRENCY: "",
          EXCHRATE: 0,
          PAYMODE: "",
          ROUTEID: 0,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        alert("Approved Successfully");
        window.location.reload();
      } else {
        console.error(`Error while Approving`);
        alert(`Error while Approving`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while Approving `, error);
      alert(error.response.data.message);
    } finally {
      setisloading(false);
    }
  }

  async function Cancel() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1442`,
        {
          MILEAGEVOUCHERNO: Number(mileageVoucherNo),
          DOCNO: requestNo ? Number(requestNo) : 0,
          MILEAGETYPE: selMileageType ? selMileageType : "",
          DRIVERCODE: selDriverCode ? selDriverCode : "",
          CANCELLEDBY: user ? user : "",
          CANCELREASON: reasonToCancel ? reasonToCancel : "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        alert("Cancelled Successfully");
        window.location.reload();
      } else {
        console.error(`Error while Cancelling`);
        alert(`Error while Cancelling`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while Cancelling `, error);
      alert(error.response.data.message);
    } finally {
      setisloading(false);
    }
  }

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          MILEAGE FOR CANTERS
        </h1>
      </div>

      <div className="flex lg:mx-2 gap-1 mt-2 lg:ml-2 ml-2">
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
            handleButtonClick("first");
          }}
        >
          {"<<"}
        </button>
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
            handleButtonClick("decrement");
          }}
        >
          {"<"}
        </button>
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
            handleButtonClick("increment");
          }}
        >
          {">"}
        </button>
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
            handleButtonClick("latest");
          }}
        >
          {">>"}
        </button>
      </div>

      {/* Line 1 */}
      <div className="lg:flex lg:flex-row justify-between mt-2 lg:ml-0 ml-2">
        <div className="lg:flex">
          <p className="lg:ml-2 ">Request No :</p>
          <input
            className="w-20 text-right h-8 border border-black lg:ml-12 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            value={requestNo}
            readOnly
          ></input>
          <button
            className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => {
              setShowRequest(true);
            }}
          >
            ...
          </button>
          <p className="lg:ml-2">Request Date :</p>
          <input
            className="w-32 h-8 border border-black lg:ml-2 rounded-md focus:outline-none focus:border-blue-500"
            type="date"
            value={date.split("T")[0]}
            onChange={(e) => setDate(e.target.value)}
          ></input>

          {hist === true && (
            <>
              <p className="lg:ml-2 font-bold text-red-500">Created By :</p>
              <p className="lg:ml-2">{createdBy}</p>
              <p className="lg:ml-2 font-bold text-red-500">Created Date :</p>
              <p className="lg:ml-2">
                {createdDate ? moment(createdDate).format("DD/MM/YYYY") : ""}
              </p>
            </>
          )}
        </div>

        {showRequest && (
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1200px] w-[95%] p-1 overflow-y-auto rounded-md">
            <div className="lg:flex lg:flex-row mt-2">
              <p className="text-red-600 lg:ml-2">Search :</p>
              <input
                className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="text"
                value={searchRequest}
                onChange={(e) => setSearchRequest(e.target.value)}
              ></input>

              <p className="text-red-600 lg:ml-2">Start Date:</p>
              <input
                className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="date"
                value={startDate?.split("T")[0]}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
              ></input>
              <p className="text-red-600 lg:ml-2">End Date:</p>
              <input
                className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="date"
                value={endDate?.split("T")[0]}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
              ></input>
            </div>

            <div className="flex justify-end gap-2">
              <div className="cursor-pointer">
                <RiFileExcel2Line onClick={ExcelStockData} size={25} />
              </div>
              <div className="cursor-pointer">
                <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
              </div>
            </div>

            <div className="visible lg:h-[430px] p-1 z-0 lg:overflow-auto mt-2">
              <table className="w-full border border-gray-300 text-sm table_1">
                <thead className="sticky top-[-1px] table-header">
                  <tr className="bg-[#2b3f5c] text-white text-[12px]">
                    <td className="py-2 px-4 text-right border border-gray-300">
                      SNO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      REQUEST NO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      REQUEST DATE
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      REF NO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      VEHICLE
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      DRIVER
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      MILEAGE TYPE
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      OPENING KM
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      CLOSING KM
                    </td>
                    {/* <td className="py-2 px-4 text-left border border-gray-300">
                      CANCELLED
                    </td> */}
                    <td className="py-2 px-4 text-left border border-gray-300">
                      NARRATION
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {filteredRequest?.map((value, index) => {
                    return (
                      <tr
                        key={value?.OT_REQUEST_NO}
                        className="hover:bg-gray-100 cursor-pointer text-[13px]"
                        onClick={() => {
                          setRequestNo(value.OT_REQUEST_NO);
                          setDate(value.OT_REQUEST_DATE);
                          setNarration(value.OT_REQUEST_NARRATION);
                          setIsDocPrinted(
                            value?.OT_REQUEST_PRINTED == true ? true : false,
                          );
                          setRefNo(value?.OT_REQUEST_INVOICE_NUMBER);
                          setCreatedBy(value?.OT_REQUEST_PROCESSED_BY);
                          setCreatedDate(value?.OT_REQUEST_PROCESSED_DATE);
                          setShowRequest(false);
                          setTruckNo(value?.OT_REQUEST_VEHICLE);
                          setMake(value?.OT_REQUEST_VEHICLE_MAKE);
                          setSelDriverCode(value?.OT_REQUEST_DRIVER_CODE);
                          setSelDriverName(value?.DRIVERNAME);
                          setOpeningKm(value?.OT_REQUEST_OPENING_KM);
                          setClosingKm(value?.OT_REQUEST_CLOSING_KM);
                          setSelMileageType(value?.OT_REQUEST_MILEAGE_TYPE);
                          setStartDate(value?.OT_REQUEST_START_DATE);
                          setEndDate(value?.OT_REQUEST_END_DATE);
                          setIsCancelled(value?.OT_REQUEST_CANCELLED);
                          setIsApproved(value?.OT_REQUEST_APPROVED);
                          const filtered = headerData?.filter(
                            (item) =>
                              item.OT_REQUEST_NO === value.OT_REQUEST_NO,
                          );

                          setTableData(filtered);
                          setHist(true);
                          setShowTable(true);
                        }}
                      >
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {index + 1}
                        </td>
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_REQUEST_NO || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_REQUEST_DATE
                            ? moment(value.OT_REQUEST_DATE).format("DD/MM/YYYY")
                            : ""}
                        </td>
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_REQUEST_INVOICE_NUMBER || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_REQUEST_VEHICLE || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.DRIVERNAME || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_REQUEST_MILEAGE_TYPE || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_REQUEST_OPENING_KM || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_REQUEST_CLOSING_KM || "N/A"}
                        </td>
                        {/* <td className="py-2 px-4 text-left border border-gray-300">
                          {value.MILEAGECANCELLED === true ? "YES" : "NO"}
                        </td> */}
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_REQUEST_NARRATION || "N/A"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <button
              className="absolute top-2 right-20 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                setPopUpReportMM(true);
                await generateReportMM();
              }}
            >
              Print Mileage Report
            </button>

            {PopUpReportMM && (
              <div>
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 99,
                  }}
                />

                {/* Popup */}
                <div
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    border: "1px solid black",
                    height: "80%",
                    width: "90%",
                    maxWidth: "90%",
                    maxHeight: "600px",
                    padding: "16px",
                    zIndex: 100,
                    overflowY: "auto",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  {LoadingScreenBlockMM && <LoadingScreen />}
                  <button
                    className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setPopUpReportMM(false)}
                  >
                    Close
                  </button>
                  <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
                    <div>
                      <section className="lg:hidden block">
                        {pdfDataMM && (
                          <button
                            className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                            onClick={handleDownloadMM}
                          >
                            Download PDF
                          </button>
                        )}
                      </section>
                      <section className="hidden lg:block">
                        {pdfDataMM ? (
                          <div className="mt-4">
                            <h2 className="text-lg font-bold">
                              Generated Report
                            </h2>
                            <object
                              key={pdfDataMM}
                              data={pdfDataMM}
                              title="Generated Report"
                              width="100%"
                              height="600px"
                            />
                          </div>
                        ) : (
                          <p className="text-2xl font-bold my-4 text-center">
                            No report available.
                          </p>
                        )}
                      </section>
                    </div>
                  </section>
                </div>
              </div>
            )}

            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setShowRequest(false)}
            >
              Close
            </button>
          </div>
        )}
      </div>

      {/* Line 2 */}

      <div className="lg:flex lg:flex-row mt-2">
        <p className="lg:ml-2">Vehicle :</p>
        <Select
          className="lg:w-48 w-48 lg:ml-20"
          value={
            truckNo
              ? { value: truckNo, label: truckNo }
              : { value: "", label: "Select Truck" }
          }
          onChange={(e) => {
            if (e.value !== "") {
              getChildData(e.value);
              setTruckNo(e.value);
              const truck = trucksList?.find(
                (item) => item?.["VEHICLE REG NO"] === e.value,
              );
              setMake(truck?.MAKE);
              setSelDriverName(truck?.DRIVERNAME);
              setSelDriverCode(truck?.DRIVERCODE);
            } else {
              setTruckNo(e.value);
            }
          }}
          options={[
            { value: "", label: "Select Truck" },
            ...trucksList?.map((item) => ({
              value: item["VEHICLE REG NO"],
              label: item["VEHICLE REG NO"],
            })),
          ]}
        ></Select>

        <p className="lg:ml-2">Make :</p>
        <input
          className="w-48 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={make}
          readOnly
        ></input>

        <p className="lg:ml-2">Driver Name :</p>
        <Select
          className="lg:w-64 w-64 lg:ml-2"
          value={
            selDriverName
              ? { value: selDriverName, label: selDriverName }
              : { value: "", label: "Select Driver" }
          }
          onChange={(e) => {
            setSelDriverName(e.label);
            setSelDriverCode(e.value);
          }}
          options={[
            { value: "", label: "Select Driver" },
            ...driverList?.map((item) => ({
              value: item.DRIVERCODE,
              label: item.DRIVERNAME,
            })),
          ]}
        ></Select>

        <p className="lg:ml-2">Opening KM :</p>
        <input
          className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="number"
          value={openingKm}
          onChange={(e) => setOpeningKm(e.target.value)}
        ></input>
        <p className="lg:ml-2">Closing KM :</p>
        <input
          className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="number"
          value={closingKm}
          onChange={(e) => setClosingKm(e.target.value)}
        ></input>
      </div>

      {/* Line 3 */}

      <div className="lg:flex lg:flex-row mt-2 lg:ml-0 ml-2">
        <p className="lg:ml-2 ">Mileage Type :</p>
        <Select
          className="lg:w-72 w-64 lg:ml-9"
          value={
            selMileageType
              ? { value: selMileageType, label: selMileageType }
              : { value: "", label: "Select Mileage Type" }
          }
          onChange={(e) => {
            if (e.value !== "") {
              setSelMileageType(e.value);
            } else {
              setSelMileageType("");
            }
          }}
          options={[
            { value: "", label: "Select Mileage Type" },
            ...mileageTypeList?.map((item) => ({
              value: item.OM_EXPENSE_CODE,
              label: item.OM_EXPENSE_CODE,
            })),
          ]}
        ></Select>

        <p className="lg:ml-2">Narration :</p>
        <textarea
          rows={2}
          className="lg:w-[400px] resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={narration}
          onChange={(e) => {
            setNarration(e.target.value);
          }}
        ></textarea>
        <p className="lg:ml-2">Ref No :</p>
        <input
          className="w-28 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="number"
          value={refNo}
          onChange={(e) => setRefNo(e.target.value)}
        ></input>
      </div>

      <div className="lg:flex lg:flex-row mt-2 lg:ml-0 ml-2">
        <p className=" lg:ml-2">Start Date:</p>
        <input
          className="w-36 h-8 border border-black lg:ml-16 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="date"
          value={headerStartDate?.split("T")[0]}
          onChange={(e) => {
            setHeaderStartDate(e.target.value);
          }}
        ></input>
        <p className="lg:ml-2">End Date:</p>
        <input
          className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="date"
          value={headerEndDate?.split("T")[0]}
          onChange={(e) => {
            setHeaderEndDate(e.target.value);
          }}
        ></input>
      </div>

      {/* Table */}
      {tableData?.length > 0 && (
        <>
          <div className="visible lg:h-[200px] p-1 z-0 lg:overflow-auto mt-2">
            {hist === true && (
              <div className="flex items-center gap-2 mt-2 lg:ml-12">
                <input
                  className="lg:ml-2 w-5 h-5"
                  type="checkbox"
                  checked={
                    tableData?.length > 0 &&
                    selectedDataForApproval?.length === tableData?.length
                  }
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
                <p className="text-blue-800 font-medium text-sm">Select All</p>
              </div>
            )}
            <table className="table-auto border border-gray-300 text-sm">
              <thead className="sticky top-0">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                  <td className="whitespace-nowrap py-2 px-4 text-right border border-gray-300">
                    SNO
                  </td>
                  <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                    LOADING NO
                  </td>
                  <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                    DATE
                  </td>
                  <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                    INVOICE NO
                  </td>
                  <td className="whitespace-nowrap py-2 px-4 text-right border border-gray-300">
                    SELECT
                  </td>
                </tr>
              </thead>
              <tbody>
                {tableData.map((value, index) => {
                  return (
                    <tr
                      key={index}
                      className="hover:bg-gray-100 cursor-pointer text-[13px]"
                      onClick={() => {
                        setSelectedRowIndex(index);
                      }}
                    >
                      <td className="whitespace-nowrap py-2 px-4 text-right border border-gray-300">
                        {index + 1}
                      </td>

                      <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                        {value.OT_LOADING_ORDER_NO || "N/A"}
                      </td>
                      <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                        {value.OT_LOADING_DATE
                          ? moment(value.OT_LOADING_DATE).format("DD/MM/YYYY")
                          : "N/A"}
                      </td>
                      <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                        {/* {value.OT_CLIENT_INVOICE_NO || "N/A"} */}
                        <input
                          className="w-64 h-8 border border-black lg:ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
                          value={value.OT_CLIENT_INVOICE_NO}
                          type="text"
                          onChange={(e) => {
                            const updatedData = [...tableData]; // copy array
                            updatedData[index] = {
                              ...updatedData[index], // copy row
                              OT_CLIENT_INVOICE_NO: e.target.value, // update field
                            };
                            setTableData(updatedData); // set new state
                          }}
                        ></input>
                      </td>

                      <td
                        className="border px-4 py-2 text-center"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <input
                          type="checkbox"
                          className="w-5 h-5"
                          checked={isRowChecked(value)}
                          onChange={() => {
                            handleCheckboxChange(value);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="lg:flex lg:flex-row mt-2 lg:ml-0 ml-2">
            <p className="lg:ml-2">KM Covered :</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={closingKm && openingKm ? closingKm - openingKm : ""}
              readOnly
            ></input>
            <p className="lg:ml-2">Shs per KM :</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={shsPerKm}
              onChange={(e) => setShsPerKm(e.target.value)}
            ></input>
            <p className="lg:ml-2">Total Amount :</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={
                closingKm && openingKm && shsPerKm
                  ? (closingKm - openingKm) * shsPerKm
                  : ""
              }
              readOnly
            ></input>
          </div>

          <div className="flex lg:justify-start lg:mr-12 lg:ml-0 ml-2 mt-2">
            <button
              className="w-28 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                window.location.reload();
              }}
            >
              New
            </button>
            {/* <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {
            if (hist === true) {
              getNewRequestNo();
              setHist(false);
              setDuplicate(true);
            } else {
              alert("Kindly save this Request No");
            }
          }}
        >
          Duplicate and New
        </button> */}
            <button
              className="w-28 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                const isInvoicePresent = headerData?.find(
                  (item) => item?.OT_REQUEST_INVOICE_NUMBER == refNo,
                );
                if (isInvoicePresent?.OT_REQUEST_NO === Number(requestNo)) {
                  await Save();
                } else {
                  if (isInvoicePresent) {
                    alert("This Ref No is attached to other Request No");
                    return;
                  } else {
                    await Save();
                  }
                }
              }}
            >
              Save
            </button>

            <button
              className="w-28 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async() => {
                if (hist === true) {
                  if (isApproved === true) {
                    alert("This Request is Already Approved");
                    return;
                  } else if (isCancelled === true) {
                    alert("This Request is Cancelled Can not Approve");
                    return;
                  } else {
                   await Approve();
                  }
                } else {
                  alert("Kindly save this Request");
                }
              }}
            >
              Approve
            </button>

            <button
              className="w-28 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async() => {
                if (hist === true) {
                  if (isCancelled === true) {
                    alert("This Request is Already Cancelled");
                    return;
                  } else if (isApproved === true) {
                    alert("This Request is Approved Can not Cancel");
                    return;
                  } else {
                    setShowCancel(true);
                  }
                } else {
                  alert("Kindly save this Request");
                }
              }}
            >
              Cancel
            </button>

            {showCancel && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[250px] h-[80%] lg:w-[600px] w-[95%] p-1 overflow-y-auto rounded-md">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Reason To Cancel :</p>
                  <textarea
                    className="w-80 resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    rows={5}
                    value={reasonToCancel}
                    onChange={(e) => setReasonToCancel(e.target.value)}
                  ></textarea>
                </div>
                <div className="flex justify-center mt-2">
                  <button
                    className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                    onClick={async () => {
                      if (!reasonToCancel) {
                        alert("Kindly provide Reason to Cancel");
                        return;
                      } else {
                        await Cancel();
                      }
                    }}
                  >
                    CANCEL
                  </button>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowCancel(false)}
                >
                  Close
                </button>
              </div>
            )}

            {/* <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={async () => {
            if (hist === true) {
              // if (isDocPrinted === false) {
              setPopUpReport(true);
              generateReport(requestNo);
              // } else {
              //   alert("The Print for this Request No is taken")
              // }
            } else {
              alert("Kindly Save the selected Request");
            }
          }}
        >
          Print
        </button> */}

            {PopUpReport && (
              <div>
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 99,
                  }}
                />

                {/* Popup */}
                <div
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    border: "1px solid black",
                    height: "80%",
                    width: "90%",
                    maxWidth: "90%",
                    maxHeight: "600px",
                    padding: "16px",
                    zIndex: 100,
                    overflowY: "auto",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  {LoadingScreenBlock && <LoadingScreen />}
                  <button
                    className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setPopUpReport(false)}
                  >
                    Close
                  </button>
                  <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
                    <div>
                      <section className="lg:hidden block">
                        {pdfData && (
                          <button
                            className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                            onClick={handleDownload}
                          >
                            Download PDF
                          </button>
                        )}
                      </section>

                      <section className="lg:block">
                        {pdfData && pdfData !== "" ? (
                          <div className="mt-4">
                            <h2 className="text-lg font-bold">
                              Generated Report
                            </h2>
                            <object
                              key={pdfData}
                              data={pdfData}
                              type="application/pdf"
                              width="100%"
                              height="600px"
                            ></object>
                          </div>
                        ) : (
                          <p className="text-2xl font-bold my-4 text-center">
                            {LoadingScreenBlock
                              ? "Loading..."
                              : "No report available."}
                          </p>
                        )}
                      </section>
                    </div>
                  </section>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MileageForCanters;
